import { useFormikContext } from 'formik';
import { useSearchableMenuFuse, SearchableMenuProvider, SearchableMenuSearchHeader, SearchableMenuSingleSelectList, } from 'shared/domains/common-ui/SearchableMenu';
export function SingleSelectList(props) {
    const { data } = props;
    const { setFieldValue, values, submitForm } = useFormikContext();
    const searchableItems = data.map((item) => (Object.assign({ id: item.value }, item)));
    const search = useSearchableMenuFuse(searchableItems, {
        keys: ['text'],
    });
    const handleOnChange = (value) => {
        setFieldValue('value', value);
        submitForm();
    };
    return (<SearchableMenuProvider {...search}>
      <SearchableMenuSearchHeader />
      <SearchableMenuSingleSelectList onSelect={(item) => handleOnChange(item.id)} renderItem={({ text }) => text} selected={values.value}/>
    </SearchableMenuProvider>);
}
